// src/utils/cropImage.js
export const getCroppedImg = (imageSrc, crop, zoom, aspect) => {
    const createImage = (url) =>
      new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener('load', () => resolve(image));
        image.addEventListener('error', (error) => reject(error));
        image.setAttribute('crossOrigin', 'anonymous'); // CORS エラーを避けるため
        image.src = url;
      });
  
    return new Promise(async (resolve, reject) => {
      try {
        const image = await createImage(imageSrc);
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
  
        const outputWidth = 400;
        const outputHeight = 400;
        canvas.width = outputWidth;
        canvas.height = outputHeight;
  
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
  
        const pixelCrop = {
          x: crop.x * scaleX,
          y: crop.y * scaleY,
          width: crop.width * scaleX,
          height: crop.height * scaleY,
        };
  
        ctx.drawImage(
          image,
          pixelCrop.x,
          pixelCrop.y,
          pixelCrop.width,
          pixelCrop.height,
          0,
          0,
          outputWidth,
          outputHeight
        );
  

  
        canvas.toBlob((blob) => {
          if (!blob) {
            console.error('Canvas is empty');
            return;
          }
          blob.name = 'cropped.jpeg';
          const fileUrl = URL.createObjectURL(blob);
          resolve({ blob, fileUrl });
        }, 'image/jpeg');
      } catch (error) {
        reject(error);
      }
    });
  };
  